import React from 'react';
import Slider from 'react-slick';
import { graphql, useStaticQuery } from 'gatsby';
import SwitchToLitCard from './switchToLitCard';

const SwitchToLit = () => {
  const data = imageQuery();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    rows: 1,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 5,
          slidesToScroll: 5,
          dots: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1060,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 760,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 530,
        settings: {
          dots: true,
          arrows: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          className: 'center',
          centerPadding: '70px',
          centerMode: true,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
    ],
  };

  return (
    <>
      <section className="location-slider">
        <h5 className="text-center">Why switch to Lit</h5>
        <Slider {...settings}>
          <SwitchToLitCard
            describe="Great value full fibre broadband that’s both ultra-fast and ultra-reliable"
            img={data.pounds}
          />
          <SwitchToLitCard
            describe="No mid-contract price rises – guaranteed"
            img={data.crossPounds}
          />
          <SwitchToLitCard
            describe="Lit fits you, with packages built for modern households"
            img={data.lines}
          />
          <SwitchToLitCard
            describe="Say goodbye to buffering with ultra-reliable full fibre broadband"
            img={data.rainbow}
          />
          <SwitchToLitCard
            describe="Fast means fast – enjoy symmetrical download and upload speeds"
            img={data.chain}
          />
          <SwitchToLitCard
            describe="Support as reliable as our fibre – available 7 days a week"
            img={data.chats}
          />
        </Slider>
      </section>
    </>
  );
};

export default SwitchToLit;

const imageQuery = () =>
  useStaticQuery(graphql`
    {
      pounds: file(relativePath: { eq: "location-images/icons/pounds.svg" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      crossPounds: file(
        relativePath: { eq: "location-images/icons/crossPounds.svg" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      lines: file(relativePath: { eq: "location-images/icons/lines.svg" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      rainbow: file(relativePath: { eq: "location-images/icons/rainbow.svg" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      chain: file(relativePath: { eq: "location-images/icons/chain.svg" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      chats: file(relativePath: { eq: "location-images/icons/chats.svg" }) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
